import ko from 'knockout';
import _ from 'lodash';
import moment from 'moment-timezone';
import templateMarkup from 'raw-loader!./historical2-dataset-view.html';
import FilterManager from '../../../app/helpers/filter-manager';
import LogiCommon from '../../../app/data-framework/logi-common';
import PreferenceService from '../../../services/preference.service';
import LoginService from "../../../services/login.service";

function HistoricalDatasetView(params) {
    var self = this;
    self.initialize(params);
}

HistoricalDatasetView.prototype = {
    initialize: function (params) {
        var self = this;

        if(_.isArray(self.subscriptions)) {
            _.forEach(self.subscriptions, function (subscription) {
                subscription.dispose();
            });
        }

        self.subscriptions = [];

        self.appId = params.appId;
        self.reportElements = null;
        self.dataProvider = params.dataProvider;
        self.route = params.route; //observable

        self.panels = ko.observableArray([]);
        self.fixedPanels = ko.observableArray([]);

        self.link = ko.pureComputed(function () {
            var route = ko.unwrap(self.route);
            return route.link;
        });

        self.tabId = ko.pureComputed(function () {
            var route = ko.unwrap(self.route);
            return route.tabId ? route.tabId.toString() : '0';
        });

        self.myView = self.route().view;

        self.subscriptions.push(self.tabId.subscribe(function(newTabId) {
            if (self.route().view === self.myView) {
                self.loaded = false;
                self.restorePreferences();
            }
        }));

        self.routeParams = ko.pureComputed(function () {
            var route = ko.unwrap(self.route);
            return route.params;
        });

        self.pageName = ko.pureComputed(function () {
            var route = ko.unwrap(self.route);
            return route.pageName;
        });

        self.datasetViewId = ko.observable(self.route().datasetViewId);

        self.shareNameDictionary = ko.pureComputed(function () {
            var route = ko.unwrap(self.route);
            return route.shareNameDictionary;
        });

        if (!!ko.unwrap(self.route).usesEndpointModels) {
            self.dataProvider.loadEndpointModels();
        }

        if (!ko.unwrap(self.pageName) || !ko.unwrap(self.datasetViewId)) {
            throw new Error('Missing route parameter for historical2-dataset-view.');
        }

        self.shareName = ko.unwrap(self.shareNameDictionary)[ko.unwrap(self.tabId)];
        if (!self.shareName) {
            throw new Error('Invalid share name for ' + ko.unwrap(self.pageName) + ' and tab ' + ko.unwrap(self.tabId));
        }

        self.currentPanelsObservable = ko.observableArray([]);
        self.currentTabFixedPanelObservable = ko.observableArray([]);

        self.timeZone = {
            id: _.get(LoginService.userObject, 'timezoneId', ''),
            text: _.get(LoginService.userObject, 'timezoneDisplay', '')
        };

        self.daysPerWeek = _.range(1, 8);
        self.selectedDaysPerWeek = ko.observable(5);
        self.hoursPerDay = _.range(1, 25);
        self.selectedHoursPerDay = ko.observable(8);

        self.urlParams = null;
        self.logiCommon = new LogiCommon();

        self.selectedDateRangeValues = ko.observable();

        self.selectedDataFilter = ko.observable();

        self.showUtilization = ko.pureComputed(function () {
            var route = ko.unwrap(self.route);
            var usesUtilization = _.get(route, 'usesUtilization');
            var utilizationTabs = _.get(route, 'utilizationTabs', []);
            return (usesUtilization && _.includes(utilizationTabs, ko.unwrap(self.tabId)));
        });

        self.daysPerWeek = _.range(1, 8);
        self.selectedDaysPerWeek = ko.observable(ko.unwrap(self.showUtilization) ? 5 : null);
        self.hoursPerDay = _.range(1, 25);
        self.selectedHoursPerDay = ko.observable(ko.unwrap(self.showUtilization) ? 8 : null);

        self.loaded = false;

        self.restorePreferences();

        self.viewLevelOptions = ko
            .pureComputed({
                read: function () {
                    var result = self.logiCommon.GetHistoricalViewLevelOptions2(
                        null,
                        self.selectedDateRangeValues(),
                        self.urlParams,
                        self.selectedDataFilter(),
                        ko.unwrap(self.selectedDaysPerWeek),
                        ko.unwrap(self.selectedHoursPerDay)
                    );
                    result.isHistoricalDataset = true;
                    if (self.loaded) {
                        return result;
                    }
                    return null;
                },
                write: function (datafilter) {
                    self.selectedDataFilter(datafilter);
                },
                owner: self
            })
            .extend({
                notify: 'always'
            });

        self.subscriptions.push(
            self.viewLevelOptions.subscribe(function () {
                if (!self.loaded || ko.unwrap(self.link)) {
                    return;
                }

                PreferenceService.saveDateRange(self.appId,
                                                self.selectedDateRangeValues());

                var dateonly = !!self.urlParams; // save date only if we have url parameters
                if (!dateonly) {
                    var tabPreferences = {
                        selectedDataFilter: self.selectedDataFilter()
                    };

                    if (ko.unwrap(self.showUtilization)) {
                        tabPreferences.selectedUtilizationValues = {
                            daysPerWeek: ko.unwrap(self.selectedDaysPerWeek),
                            hoursPerDay: ko.unwrap(self.selectedHoursPerDay)
                        };
                    }

                    PreferenceService.saveTabOptions(
                        self.appId,
                        ko.unwrap(self.datasetViewId),
                        ko.unwrap(self.tabId),
                        tabPreferences
                    );

                    self.selectedDataFilter.valueHasMutated();
                }
            }),
            self.route.subscribe(function(newValue) {
                let routeViewId = newValue.datasetViewId;
                let currentViewId = ko.unwrap(self.datasetViewId);
                if (currentViewId && currentViewId != routeViewId) {
                    self.loaded = false;
                }
                self.datasetViewId(routeViewId);
            }),
        );
    },

    restorePreferences: function () {
        var self = this;
        var unwrappedView = ko.unwrap(self.datasetViewId);
        if (unwrappedView === undefined) {
            // There are times when the datasetViewId isn't defined. For instance,
            // after you navigate to a new page, the subscription on the routeParams
            // is getting called before the subscription is disposed of
            // (because we reuse the same route params for the entire app's existence,
            // we can't rely on the subscription notification to occur
            // while you are still on the same page).
            // In those cases where the datasetViewId is undefined, we don't know what to restore,
            // so we'll return.
            return;
        }
        return PreferenceService
            .getTabOptions(self.appId, unwrappedView, ko.unwrap(self.tabId))
            .then(function (prefs) {
                if (prefs) {
                    if (ko.unwrap(self.showUtilization) && prefs.selectedUtilizationValues) {
                        self.selectedDaysPerWeek(prefs.selectedUtilizationValues.daysPerWeek);
                        self.selectedHoursPerDay(prefs.selectedUtilizationValues.hoursPerDay);
                    }

                    if (!ko.unwrap(self.link) && !ko.unwrap(self.routeParams)) {
                        PreferenceService.getDateRange(self.appId).then((dateRange) => {
                          if (typeof self.selectedDateRangeValues === 'function') {
                              self.selectedDateRangeValues({
                                  startDate: moment(dateRange.startDate),
                                  endDate: moment(dateRange.endDate)
                              });
                          }
                          self.loaded = true;
                        }).finally(() => self.selectedDataFilter(prefs.selectedDataFilter));
                    }
                }

                if (ko.unwrap(self.routeParams)) {
                    let urlParams = self.urlParams = self.logiCommon.getParamsObject(ko.unwrap(self.routeParams));


                    var filters = [];

                    if (urlParams.hasFilters === "true") {
                        filters = FilterManager.getCurrentFilters();
                        if (filters.inpStartDate && filters.inpEndDate) {
                            self.selectedDateRangeValues({
                                startDate: moment(self.logiCommon.removeTimePortion(filters.inpStartDate)),
                                endDate: moment(self.logiCommon.removeTimePortion(filters.inpEndDate))
                            });
                        }
                    }

                    // url params take precident over session filters
                    if (urlParams.inpstartdate && urlParams.inpenddate) {
                        self.selectedDateRangeValues({
                            startDate: moment(self.logiCommon.removeTimePortion(urlParams.inpstartdate)),
                            endDate: moment(self.logiCommon.removeTimePortion(urlParams.inpenddate))
                        });
                    }

                    if (urlParams.WhereCondition) {
                        self.selectedDataFilter(
                            urlParams.WhereCondition
                        );

                    } else {
                        self.selectedDataFilter(filters.WhereConditionObj);
                    }

                    self.loaded = true;
                    self.selectedDataFilter.valueHasMutated();

                } else {
                    self.urlParams = null;
                    if (ko.unwrap(self.link)) {
                        self.dataProvider
                        .getTokenParams(ko.unwrap(self.link))
                        .then(function (tokenParams) {
                            if (tokenParams) {
                                self.selectedDateRangeValues({
                                    startDate: moment(tokenParams.inpStartDate, 'YYYY/MM/DD'),
                                    endDate: moment(tokenParams.inpEndDate, 'YYYY/MM/DD')
                                });

                                if (ko.unwrap(self.showUtilization) && tokenParams.daysPerWeek) {
                                    self.selectedDaysPerWeek(tokenParams.daysPerWeek);
                                    self.selectedHoursPerDay(tokenParams.hoursPerDay);
                                }

                                if (tokenParams.WhereConditionObj) {
                                    self.selectedDataFilter(tokenParams.WhereConditionObj);
                                }

                            } else {
                                alert('Invalid link');
                            }

                            self.loaded = true;
                            self.selectedDataFilter.valueHasMutated();
                        });

                    }
                }
            });
    },

    dispose: function () {
        var self = this;
        _.forEach(self.subscriptions, function (subscription) {
            subscription.dispose();
        });

    }
};

export default { template: templateMarkup, viewModel: HistoricalDatasetView };
